export default function isInBrowser() {
    return typeof window !== 'undefined';
}
